import { Stack } from '@mantine/core';
import { useNavigate } from 'react-router';
import { useCreateFinancialItem } from 'src/financial/financial-data/financial-item/useCreateFinancialItem';
import { FinancialItems } from 'src/financial/financial-data/hooks/useFinancialItems';
import { CreateNewPill } from './CreateNewPill';
import { FinancialSectionTable } from './FinancialSectionTable';
import { FinancialRow, buildCategories, extractRows } from './financialRows';

type Props = {
  clientId: string;
  clientFirstName: string;
  financialItems: FinancialItems;
};

export function FinancialContentRework({ clientId, clientFirstName, financialItems }: Props) {
  const navigate = useNavigate();
  const { beginCreate, modals } = useCreateFinancialItem({ clientId });

  const categories = buildCategories(extractRows(financialItems, clientFirstName));

  const handleRowClick = (row: FinancialRow) => {
    navigate(`/client/${clientId}/financial-items/${row.navProduct}/${row.id}`);
  };

  return (
    <Stack gap="lg">
      <CreateNewPill
        onCreateSpending={() => beginCreate('SPENDING_ACCOUNT', 'SpendingAccount')}
        onCreateProtection={() => beginCreate('PROTECTION', 'Protection')}
        onCreateAsset={product => beginCreate('ASSET', product)}
        onCreateLiability={product => beginCreate('LIABILITY', product)}
      />
      {categories.map(category => (
        <FinancialSectionTable
          key={category.key}
          title={category.title}
          rows={category.rows}
          total={category.total}
          totalLabel={category.totalLabel}
          subSections={category.subSections}
          onRowClick={handleRowClick}
        />
      ))}
      {modals}
    </Stack>
  );
}
